import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
// import MoreIcon from "@mui/icons-material/MoreVert";
import { HeaderNavBar } from "./Header.style";
import LogoWrapper from "../LogoWrapper";
import SearchAppBar from "./SearchAppBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { clearAuthDetails, setIsLoggedIn } from "../../../actions";
import { decodeUserToken } from "../../../utils";
import styled from "styled-components";
// import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

const Header = () => {
  const dispatch = useDispatch();
  const { isAuthenticated = true } = decodeUserToken();
  // eslint-disable-next-line no-unused-vars
  const cartItemslist = useSelector(
    (state) => state.AllCartItems?.AllCartData || {}
  );
  const userDetails = useSelector((state) => state.userDetails || {});
  const { userProfile = {} } = userDetails;
  const { fullName = "", isAuthUser = false } = userProfile;
  const splitFirstName = (fullName?.length && fullName?.split(" ")[0]) || "";
  // eslint-disable-next-line no-unused-vars
  const [auth, setAuth] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartView, setCartView] = useState(false);
  const [checkoutView, setCheckoutView] = useState(false);
  const [openCategories, setOpenCategories] = useState(new Set());

  const navigate = useNavigate();

  const handleNaviate = (sub) => {
    navigate(`/products/${sub.id}`);
    setMenuOpen(false);
  };

  const toggleCategory = (index) => {
    const updated = new Set(openCategories);
    if (updated.has(index)) {
      updated.delete(index);
    } else {
      updated.add(index);
    }
    setOpenCategories(updated);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleMenuItems = (e) => {
    const text = e.currentTarget?.innerText || "";
    if (text === "Logout") {
      localStorage.removeItem("userToken");
      dispatch(clearAuthDetails());
      window.location.href = "/";
    }
  };
  const params = useLocation();
  const cartPath = params?.pathname?.split("/")[1] || "";

  useEffect(() => {
    if (cartPath === "viewcart" || cartPath === "buynow") {
      setCartView(true);
    } else if (cartPath === "checkout") {
      setCheckoutView(true);
    } else {
      setCartView(false);
      setCheckoutView(false);
    }
    if (!isAuthUser && !isAuthenticated) {
      dispatch(setIsLoggedIn(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartPath, cartView, checkoutView]);

  useEffect(() => {
    setAuth(isAuthUser);
    if (!isAuthUser && !isAuthenticated) {
      dispatch(setIsLoggedIn(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthUser]);

  const HeaderTop = styled.div`
    width: 100%;
    height: 25px;
    background-color: #f05a21;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 13px;
  `;
  const SearchContainer = styled.div`
    display: none;
    padding-top: 2rem;
    padding-bottom: 1rem;

    @media (max-width: 600px) {
      display: flex;
      margin-top: 2.7rem;
      width: 100%;
      position: fixed;
      background-color: #fff;
    }
  `;

  const RightShowUpContainer = styled.div`

  position: fixed;
  top: 0;
  left: 0;


  transform: ${({ menuOpen }) =>
    menuOpen ? "translateX(0)" : "translateX(-100%)"};
  transition: transform 0.3s ease-in-out;


top:0;
transition: all .3s;
width:100vw;
height:100vh;
background-color:#f2f2f2;
z-index:2222;

flex-direction:column;
justify-content:center;
align-items:center;
overflow-y:scroll;



}


@media (min-width: 900px) {

display: none;

}



`;

  const MenuTop = styled.div`
    width: 100%;
    background-color: #fff;
    height: 81px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 2rem;

    img {
      margin-left: 1rem;
      padding: 2rem;
      padding-left: 0px;
      width: 90px;
    }

    svg {
      width: 15px;
    }
  `;

  const List = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    background-color: #fff;
  `;

  const ListItem = styled.div`

justify-content:center;
align-items:center;
display:flex;
width:100%;
background-color:#fff;
width:100%;
position:relative;

.listitems{
width:100%;
padding: 1rem 1rem;
display:flex;
justify-content:flex-start;
border-bottom:1px solid rgba(145, 145, 145, 0.17);
font-size:15px;
color:#667;
font-family: "Ancizar Sans", sans-serif;

}
a{
width:100%;
}

svg{
    width: 9px;
    height: 11px;
    position: absolute;
    right: 22px;
    top: 22px;
}
}


`;
  const listoptions = [
    { name: "My Profile", link: "/account?AM=profile" },
    { name: "Orders", link: "/myaccount/orders" },
    { name: "WishList", link: "/account?AM=wishlist" },
    { name: "Login", link: "/login" },
    { name: "Logout", link: "/" },
  ];

  const CatList = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
width: 100%;

background-color: #fff;


.catlistitemheader{
padding: .5rem 1rem;
position: relative;

border-bottom:1px solid rgba(145, 145, 145, 0.17);
width: 100%;
p{
font-size: 15px;
    font-family: "Ancizar Sans", sans-serif;
color: #667;
font-weight: 400;
margin: .5rem 1px;
}

}

svg {
width: 9px;
    height: 11px;
    position: absolute;
    right: 22px;
    top: 22px;}
}


.catlistchilditem{

transition: all .5s ease-in-out;


}
 .open{
 min-height: 200px;
 transition: all .5s ease-in-out;
 } 

.catlistchilditem p {
font-size:15px;
margin: 1.2rem 1px !important;
transition: all .5s ease-in-out;
}

.listheightmaain{
transition: all .5s ease-in-out;

}

.openmain{
transition: all .5s ease-in-out;
min-height: 200px;
}
.catlistitemheader{
transition: all .5s ease-in-out;
min-height: 50px;
}

`;

  const RighteMenu = styled.div`
    display: ${anchorElUser ? "flex" : "none"};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 211px;

    background-color: #fff;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);

    position: fixed;
    right: 3rem;
    top: 5rem;
  `;
  const MenuListItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
  `;
  const GuestContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;

    .guestcontainer {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      border-bottom: 1px solid rgba(145, 145, 145, 0.17);
    }

    .guestcontainer p:first-child {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0.2rem;
      margin-top: 0;
      color: #333;
    }

    .guestcontainer p:nth-child(2) {
      font-size: 13px;
      font-weight: 400;
      margin-bottom: 0.5rem;
      color: #777;
      margin-top: 0;
    }
  `;
  const LoggedContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
    min-height: 100px;
  `;
  const Loggedlist = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 14px;
    font-family: "Ancizar Sans", sans-serif;
    border-bottom: 1px solid rgba(145, 145, 145, 0.17);
    cursor: pointer;

    p {
      color: #333;
      font-weight: 600;
      font-size: 16px;
      margin-left: 1rem;
    }
  `;

  const LoginButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    font-size: 14px;
    font-family: "Ancizar Sans", sans-serif;
    background-color: rgb(116, 240, 33);
    border: none;
    outline: #fff;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  `;

  const BadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 21px;
  height: 21px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 50%;
  position: absolute;
  left: 5px;
  top: 16px;
  font-family: "Ancizar Sans", sans-serif;
  background-color: #fff;
  background-color: rgb(116, 240, 33);
  
  `

  const handleLoginClick = () => {
    navigate("/login");
    setAnchorElUser(null);
    setMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    dispatch(clearAuthDetails());   
  window.location.href = "/"; 
  };


  const cat = useSelector((state) => state.categories || []);

   const cartList = useSelector(
      (state) => state?.AllCartItems?.AllCartData || {}
    );

    console.log("cart item list",cartItemslist );

  const isMobile = window.innerWidth > 900 ? false : true;

  return (
    <>
      <HeaderNavBar id="app-bar-header" style={{ backgroundColor: "#fff" }}>
        {/* <HeaderTop> Get Up to 40% OFF New-Season Styles </HeaderTop> */}
        <AppBar
          position="static"
          id="app-bar"
          className="app-bar"
          style={{
            backgroundColor: "#fff",
            boxShadow: "none",
            position: "fixed",
            zIndex: 1000,
          }}
        >
          <Container maxWidth="xl">
            <Toolbar disableGutters className="toolbar">
              <Link to="/" className="header_logo">
                <LogoWrapper className="logoWrapper" />
              </Link>
              {!checkoutView && (
                <>
                  <Box
                    sx={{
                      /*  */ flexGrow: 1,
                      display: { xs: "none", sm: "block" },
                    }}
                  >
                    <SearchAppBar />
                  </Box>
                  <Box sx={{ flexGrow: 1 }} />
                  <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="Account Details">
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        {!auth ? (
                          <>
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 26 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 0.25C10.4783 0.25 8.01321 0.997774 5.91648 2.39876C3.81976 3.79975 2.18556 5.79103 1.22054 8.12079C0.255524 10.4505 0.00303191 13.0141 0.494993 15.4874C0.986955 17.9607 2.20127 20.2325 3.98439 22.0156C5.76751 23.7987 8.03935 25.0131 10.5126 25.505C12.9859 25.997 15.5495 25.7445 17.8792 24.7795C20.209 23.8144 22.2003 22.1802 23.6012 20.0835C25.0022 17.9868 25.75 15.5217 25.75 13C25.746 9.61971 24.4015 6.379 22.0112 3.98877C19.621 1.59854 16.3803 0.25397 13 0.25ZM5.93001 21.75C6.66349 20.5303 7.70003 19.5212 8.93889 18.8206C10.1777 18.12 11.5768 17.7518 13 17.7518C14.4232 17.7518 15.8223 18.12 17.0611 18.8206C18.3 19.5212 19.3365 20.5303 20.07 21.75C18.0705 23.3714 15.5743 24.2563 13 24.2563C10.4257 24.2563 7.92955 23.3714 5.93001 21.75ZM8.75001 12C8.75001 11.1594 8.99926 10.3377 9.46626 9.63883C9.93326 8.93992 10.597 8.39518 11.3736 8.07351C12.1502 7.75184 13.0047 7.66767 13.8291 7.83166C14.6536 7.99565 15.4108 8.40042 16.0052 8.9948C16.5996 9.58917 17.0044 10.3464 17.1683 11.1709C17.3323 11.9953 17.2482 12.8498 16.9265 13.6264C16.6048 14.403 16.0601 15.0668 15.3612 15.5337C14.6623 16.0007 13.8406 16.25 13 16.25C11.8728 16.25 10.7918 15.8022 9.9948 15.0052C9.19777 14.2082 8.75001 13.1272 8.75001 12ZM21.1888 20.705C20.0103 18.8727 18.2489 17.4908 16.1888 16.7825C17.216 16.0983 17.9959 15.1016 18.413 13.9399C18.8301 12.7783 18.8623 11.5132 18.5049 10.3318C18.1475 9.15035 17.4194 8.11531 16.4282 7.37968C15.4371 6.64404 14.2356 6.24686 13.0013 6.24686C11.767 6.24686 10.5654 6.64404 9.57429 7.37968C8.58316 8.11531 7.85505 9.15035 7.49762 10.3318C7.14019 11.5132 7.17241 12.7783 7.58952 13.9399C8.00662 15.1016 8.78647 16.0983 9.81376 16.7825C7.75358 17.4908 5.99217 18.8727 4.81376 20.705C3.30729 19.1064 2.30179 17.1017 1.92131 14.9382C1.54082 12.7748 1.80201 10.5474 2.67264 8.53066C3.54327 6.51396 4.98524 4.79624 6.82066 3.58946C8.65609 2.38267 10.8046 1.7396 13.0013 1.7396C15.1979 1.7396 17.3464 2.38267 19.1818 3.58946C21.0173 4.79624 22.4592 6.51396 23.3299 8.53066C24.2005 10.5474 24.4617 12.7748 24.0812 14.9382C23.7007 17.1017 22.6952 19.1064 21.1888 20.705Z"
                                fill="#343330"
                              />
                            </svg>
                          </>
                        ) : (
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1, color: "#333", fontSize: 13 }}
                          >
                            {splitFirstName?.toUpperCase() || "Login"}
                          </Typography>
                        )}
                      </IconButton>
                    </Tooltip>

                    <RighteMenu onMouseLeave={() => setAnchorElUser(false)}>
                      {auth && <MenuListItem>profile</MenuListItem>}
                      {!auth && (
                        <>
                          <GuestContainer>
                            <div className="guestcontainer">
                              <p>Hello User</p>
                              <p>to access your account</p>
                              <LoginButton onClick={handleLoginClick}>
                                Login
                              </LoginButton>
                            </div>
                          </GuestContainer>
                        </>
                      )}

                      {auth && (
                        <>
                          <LoggedContainer >
                            <Loggedlist onClick={()=>{navigate('/account?AM=profile')}}>
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 4C11.5 5.65685 10.1569 7 8.5 7C6.84315 7 5.5 5.65685 5.5 4C5.5 2.34315 6.84315 1 8.5 1C10.1569 1 11.5 2.34315 11.5 4Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 17C15.5246 7.66667 1.47538 7.66667 1 17" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  <p>profile</p>
                            </Loggedlist>
                            <Loggedlist>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 19C15.3284 19 16 18.3284 16 17.5C16 16.6716 15.3284 16 14.5 16C13.6716 16 13 16.6716 13 17.5C13 18.3284 13.6716 19 14.5 19Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.5 19C7.32843 19 8 18.3284 8 17.5C8 16.6716 7.32843 16 6.5 16C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.70907 3.4H16.9241C18.3017 3.4 19.2968 4.67056 18.9194 5.94783L17.2649 11.5478C17.011 12.4072 16.1965 13 15.2696 13H6.11164C5.18469 13 4.37021 12.4072 4.11631 11.5478L1.70907 3.4ZM1.70907 3.4L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                              <p onClick={()=>{navigate('/myaccount/orders')}}>orders</p>
                            </Loggedlist>
                             <Loggedlist style={{ borderBottom: "none" }} onClick={()=>{navigate(`account?AM=wishlist`)}}>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.75 1.5C3.12665 1.5 1 3.75956 1 6.54688C1 12.125 10 18.5 10 18.5C10 18.5 19 12.125 19 6.54688C19 3.09375 16.8734 1.5 14.25 1.5C12.39 1.5 10.7796 2.63593 10 4.2905C9.22036 2.63593 7.61003 1.5 5.75 1.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<p>wishlist</p>
                            </Loggedlist>
                           {auth?<> <Loggedlist style={{ borderBottom: "none" }} onClick={()=>{handleLogout()}}>
                              <svg width="19" height="19" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 6.99995H13M13 6.99995L9.86584 10.3333M13 6.99995L9.86584 3.66663" strokeWidth="1.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.66666 1L3 1C2.05719 1 1.58578 1 1.29289 1.29289C0.999996 1.58579 0.999996 2.05719 0.999996 3L0.999996 11C0.999996 11.9428 0.999996 12.4142 1.29289 12.7071C1.58578 13 2.05719 13 3 13H5.66666" strokeWidth="1.5" stroke="#222222" stroke-linecap="round"/>
</svg>

<p>Log out</p>
                            </Loggedlist></>:<> <Loggedlist style={{ borderBottom: "none" }} onClick={()=>{navigate(`account?AM=wishlist`)}}>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.75 1.5C3.12665 1.5 1 3.75956 1 6.54688C1 12.125 10 18.5 10 18.5C10 18.5 19 12.125 19 6.54688C19 3.09375 16.8734 1.5 14.25 1.5C12.39 1.5 10.7796 2.63593 10 4.2905C9.22036 2.63593 7.61003 1.5 5.75 1.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<p>Log in</p>
                            </Loggedlist></>}
                          </LoggedContainer>
                        </>
                      )}
                    </RighteMenu>
                  </Box>
                  {!cartView && (
                    <React.Fragment>
                      <Box sx={{ flexGrow: 0, display: "block" }}>
                        <Tooltip title="Cart">
                          <IconButton
                            size="small"
                            aria-label="show cart"
                            color="inherit"
                          >
                            <Badge
                              badgeContent={cartItemslist?.length}
                              color="error"
                            >
                              <Link to="/viewcart">
                                <svg
                                  width="21"
                                  height="21"
                                  viewBox="0 0 27 27"
                                  style={{
                                    marginTop: 8,
                                    marginLeft: 15,
                                    marginRight: 9,
                                  }}
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M26.5763 5.52C26.5059 5.4355 26.4178 5.36751 26.3182 5.32085C26.2186 5.27419 26.11 5.25 26 5.25H5.625L4.82875 0.86625C4.79743 0.693434 4.70645 0.53709 4.57168 0.424474C4.4369 0.311858 4.26688 0.250112 4.09125 0.25H1C0.801088 0.25 0.610322 0.329018 0.46967 0.46967C0.329018 0.610322 0.25 0.801088 0.25 1C0.25 1.19891 0.329018 1.38968 0.46967 1.53033C0.610322 1.67098 0.801088 1.75 1 1.75H3.465L6.69125 19.4925C6.7924 20.0519 7.06498 20.5661 7.47125 20.9638C6.98028 21.3559 6.61353 21.882 6.4154 22.4783C6.21727 23.0746 6.19625 23.7156 6.3549 24.3236C6.51354 24.9316 6.84504 25.4806 7.30926 25.9041C7.77348 26.3276 8.35052 26.6074 8.9705 26.7097C9.59049 26.812 10.2268 26.7324 10.8025 26.4805C11.3782 26.2286 11.8685 25.8152 12.214 25.2904C12.5596 24.7656 12.7456 24.1518 12.7495 23.5235C12.7535 22.8951 12.5752 22.2791 12.2362 21.75H18.7638C18.3751 22.3582 18.2 23.0785 18.266 23.7973C18.332 24.5161 18.6354 25.1924 19.1284 25.7197C19.6214 26.2469 20.2758 26.595 20.9886 26.7091C21.7013 26.8232 22.4317 26.6968 23.0646 26.3499C23.6976 26.0029 24.197 25.4551 24.4841 24.7929C24.7713 24.1306 24.8298 23.3917 24.6504 22.6925C24.4711 21.9933 24.0641 21.3738 23.4937 20.9315C22.9232 20.4892 22.2218 20.2495 21.5 20.25H9.39625C9.10351 20.25 8.82003 20.1473 8.59525 19.9598C8.37048 19.7723 8.21865 19.5118 8.16625 19.2237L7.71625 16.75H22.5125C23.1565 16.7502 23.7802 16.5243 24.2748 16.1117C24.7693 15.6992 25.1034 15.1261 25.2188 14.4925L26.7375 6.13375C26.7571 6.02588 26.7528 5.91502 26.725 5.80898C26.6971 5.70294 26.6464 5.6043 26.5763 5.52ZM11.25 23.5C11.25 23.8461 11.1474 24.1845 10.9551 24.4722C10.7628 24.76 10.4895 24.9843 10.1697 25.1168C9.84993 25.2492 9.49806 25.2839 9.15859 25.2164C8.81913 25.1488 8.5073 24.9822 8.26256 24.7374C8.01782 24.4927 7.85115 24.1809 7.78363 23.8414C7.7161 23.5019 7.75076 23.1501 7.88321 22.8303C8.01566 22.5105 8.23997 22.2372 8.52775 22.0449C8.81554 21.8526 9.15388 21.75 9.5 21.75C9.96413 21.75 10.4092 21.9344 10.7374 22.2626C11.0656 22.5908 11.25 23.0359 11.25 23.5ZM23.25 23.5C23.25 23.8461 23.1474 24.1845 22.9551 24.4722C22.7628 24.76 22.4895 24.9843 22.1697 25.1168C21.8499 25.2492 21.4981 25.2839 21.1586 25.2164C20.8191 25.1488 20.5073 24.9822 20.2626 24.7374C20.0178 24.4927 19.8512 24.1809 19.7836 23.8414C19.7161 23.5019 19.7508 23.1501 19.8832 22.8303C20.0157 22.5105 20.24 22.2372 20.5278 22.0449C20.8155 21.8526 21.1539 21.75 21.5 21.75C21.9641 21.75 22.4092 21.9344 22.7374 22.2626C23.0656 22.5908 23.25 23.0359 23.25 23.5ZM23.7425 14.2237C23.6901 14.5118 23.5383 14.7723 23.3135 14.9598C23.0887 15.1473 22.8052 15.25 22.5125 15.25H7.44375L5.89875 6.75H25.1012L23.7425 14.2237Z"
                                    fill="#343330"
                                  />
                                </svg>
                               {cartItemslist?.shipments?.length > 0 && <> <BadgeContainer>{cartItemslist.shipments.length}</BadgeContainer></>}
                              </Link>
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      </Box>
                      {!isMobile ? (
                        <></>
                      ) : (
                        <Box sx={{ flexGrow: 0, display: "block" }}>
                          <Tooltip title="Cart">
                            <IconButton
                              size="small"
                              aria-label="meu"
                              color="inherit"
                            >
                              <Badge
                                badgeContent={cartItemslist?.length}
                                color="error"
                              >
                                <Link
                                  onClick={() => {
                                    setMenuOpen(true);
                                  }}
                                >
                                  <svg
                                    width="21"
                                    height="13"
                                    style={{ marginTop: 7 }}
                                    viewBox="0 0 314 177"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      width="214"
                                      height="25"
                                      rx="12.5"
                                      fill="#363636"
                                    />
                                    <rect
                                      y="76"
                                      width="214"
                                      height="25"
                                      rx="12.5"
                                      fill="#363636"
                                    />
                                    <rect
                                      y="152"
                                      width="214"
                                      height="25"
                                      rx="12.5"
                                      fill="#363636"
                                    />
                                  </svg>
                                </Link>
                              </Badge>
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                      {/* <Box sx={{ flexGrow: 0, display: "block" }}>
                      <Tooltip title="Become a Seller">
                        <IconButton
                          size="small"
                          aria-label="show cart"
                          color="inherit"
                        >
                          <a
                            href="https://clanadminportal-test.up.railway.app/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <StorefrontOutlinedIcon
                              sx={{
                                display: { xs: "flex", md: "flex" },
                                fontFamily: "monospace",
                                fontWeight: 700,
                                letterSpacing: ".3rem",
                                color: "white",
                                textDecoration: "none",
                              }}
                            />
                          </a>
                        </IconButton>
                      </Tooltip>
                    </Box> */}
                      {/* <Box
                      sx={{ flexGrow: 0, display: { xs: "none", sm: "block" } }}
                    >
                      <Tooltip title="More">
                        <IconButton
                          size="large"
                          aria-label="display more actions"
                          edge="end"
                          color="inherit"
                        >
                          <MoreIcon />
                        </IconButton>
                      </Tooltip>
                    </Box> */}
                      {auth && !isMobile && (
                        <Box
                          sx={{
                            flexGrow: 0,
                            display: "block",
                            marginTop: ".6rem",
                          }}
                        >
                          <Tooltip title="Wishlist">
                            <IconButton
                              size="small"
                              aria-label="meu"
                              color="inherit"
                            >
                              <Badge
                                badgeContent={cartItemslist?.length}
                                color="error"
                              >
                                <Link to={`account?AM=wishlist`}>
                                  <svg
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 50 50"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M25 39.7l-.6-.5C11.5 28.7 8 25 8 19c0-5 4-9 9-9 4.1 0 6.4 2.3 8 4.1 1.6-1.8 3.9-4.1 8-4.1 5 0 9 4 9 9 0 6-3.5 9.7-16.4 20.2l-.6.5zM17 12c-3.9 0-7 3.1-7 7 0 5.1 3.2 8.5 15 18.1 11.8-9.6 15-13 15-18.1 0-3.9-3.1-7-7-7-3.5 0-5.4 2.1-6.9 3.8L25 17.1l-1.1-1.3C22.4 14.1 20.5 12 17 12z" />
                                  </svg>
                                </Link>
                              </Badge>
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </React.Fragment>
                  )}
                </>
              )}
            </Toolbar>
          </Container>
        </AppBar>
        {!checkoutView && (
          <Box
            sx={{
              flexGrow: 1,
              p: 1,
              color: "black",
              backgroundColor: "white",
              display: { xs: "flex", md: "none", sm: "none" },
            }}
          >
            <SearchAppBar placeHolder={"Search for Products, Brands"} />
          </Box>
        )}
        <RightShowUpContainer menuOpen={menuOpen}>
          <MenuTop>
            <img src="/favicon.png" style={{ marginTop: 20 }} />

            <div
              onClick={() => {
                setMenuOpen(false);
              }}
            >
              <svg
                width="129"
                height="129"
                viewBox="0 0 129 129"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="-2"
                  y="121.429"
                  width="174.555"
                  height="13.8977"
                  rx="6.94886"
                  transform="rotate(-45 -2 121.429)"
                  fill="#363636"
                />
                <rect
                  x="8"
                  y="-1.5708"
                  width="174.555"
                  height="13.8977"
                  rx="6.94886"
                  transform="rotate(45 8 -1.5708)"
                  fill="#363636"
                />
              </svg>
            </div>
          </MenuTop>
          <List>
            {listoptions.map((item) => {
              return (
                <ListItem
                  key={item.name}
                  onClick={() => {
                    handleMenuItems(item.name);
                    setMenuOpen(false);
                  }}
                >
                  <Link
                    to={`${item.link}`}
                    style={{ textDecoration: "none", color: "#333" }}
                  >
                    <div className="listitems">{item.name}</div>
                    <svg
                      width="143"
                      height="211"
                      viewBox="0 0 143 211"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="-1.12012"
                        y="201.99"
                        width="174.555"
                        height="13.8977"
                        rx="6.94886"
                        transform="rotate(-37.6037 -1.12012 201.99)"
                        fill="#555"
                      />
                      <rect
                        x="6.27002"
                        y="-2.67993"
                        width="174.555"
                        height="13.8977"
                        rx="6.94886"
                        transform="rotate(37.3964 6.27002 -2.67993)"
                        fill="#555"
                      />
                    </svg>
                  </Link>
                </ListItem>
              );
            })}
          </List>
          <CatList>
            {cat.map((category, index) => (
              <div
                key={index}
                className={`catlistitemheader ${
                  openCategories.has(index) ? "openmain" : ""
                }`}
              >
                <p
                  onClick={() => toggleCategory(index)}
                  style={{ cursor: "pointer" }}
                >
                  {category.name}
                </p>

                <svg
                  style={{
                    transform: openCategories.has(index)
                      ? "rotate(90deg)"
                      : "rotate(0deg)",
                  }}
                  width="143"
                  height="211"
                  viewBox="0 0 143 211"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="-1.12012"
                    y="201.99"
                    width="174.555"
                    height="13.8977"
                    rx="6.94886"
                    transform="rotate(-37.6037 -1.12012 201.99)"
                    fill="#555"
                  ></rect>
                  <rect
                    x="6.27002"
                    y="-2.67993"
                    width="174.555"
                    height="13.8977"
                    rx="6.94886"
                    transform="rotate(37.3964 6.27002 -2.67993)"
                    fill="#555"
                  ></rect>
                </svg>

                <div
                  className={`listheightmaain ${
                    openCategories.has(index) ? "open" : ""
                  }`}
                  style={{
                    minHeight: openCategories.has(index) ? "100px" : "0px",
                  }}
                >
                  {openCategories.has(index) &&
                    category.children?.length > 0 && (
                      <div
                        className={`catlistchilditem ${
                          openCategories.has(index) ? "open" : ""
                        }`}
                      >
                        {category.children.map((child, childIndex) => (
                          <p
                            key={childIndex}
                            onClick={() => {
                              handleNaviate(child);
                            }}
                          >
                            {child.name}
                          </p>
                        ))}
                      </div>
                    )}
                </div>
              </div>
            ))}
          </CatList>
        </RightShowUpContainer>
        <SearchContainer>
          <SearchAppBar />
        </SearchContainer>
      </HeaderNavBar>
    </>
  );
};

export default Header;

/*    <Menu
                      sx={{ mt: "25px" }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >
                      {auth && (
                        <MenuItem
                          key={"MyProfile"}
                          onClick={handleCloseUserMenu}
                        >
                          <Link
                            to={`/account`}
                            style={{ textDecoration: "none" }}
                          >
                            <Typography textAlign="center" color="#333">
                              {"My Profile"}
                            </Typography>
                          </Link>
                        </MenuItem>
                      )}
                      <MenuItem key={"Orders"} onClick={handleCloseUserMenu}>
                        <Link
                          to={`${!auth ? "/login" : "/myaccount/orders"}`}
                          style={{ textDecoration: "none" }}
                        >
                          <Typography textAlign="center" color="text.primary">
                            {"Orders"}
                          </Typography>
                        </Link>
                      </MenuItem>
                      <MenuItem key={"WishList"} onClick={handleCloseUserMenu}>
                        <Link
                          to={`${!auth ? "/login" : "/account?AM=wishlist"}`}
                          style={{ textDecoration: "none" }}
                        >
                          <Typography textAlign="center" color="text.primary">
                            {"WishList"}
                          </Typography>
                        </Link>
                      </MenuItem>
                      {!auth && (
                        <MenuItem key={"Login"} onClick={handleCloseUserMenu}>
                          <Link
                            to={`/login`}
                            style={{ textDecoration: "none" }}
                          >
                            <Typography textAlign="center" color="text.primary">
                              {"Login"}
                            </Typography>
                          </Link>
                        </MenuItem>
                      )}
                      {auth && (
                        <MenuItem key={"Logout"} onClick={handleMenuItems}>
                          <Link to={`/`} style={{ textDecoration: "none" }}>
                            <Typography textAlign="center" color="text.primary">
                              {"Logout"}
                            </Typography>
                          </Link>
                        </MenuItem>
                      )}
                    </Menu> */
